$(() => {
    // Verifica hash ao iniciar
    URI.init();

    (<any>$('#p5fw-accessibility-buttons')).p5fwAccessibility();

    //PopUP's
    if ($("#popupModal").length === 1) {
        if (!getWithExpiry('popupShown')) {
            (<any>$('#popupModal')).modal('show');
            setWithExpiry('popupShown', true, 120000);
        }
    }

    // Menu
    $('.m-m-submenu a').click(function () {
        $(this).parent('.m-m-submenu').hide();
    });

    $('.m-menu').hover(
        function () {
            $(this).find('.m-m-submenu').slideDown();
        },
        function () {
            $(this).find('.m-m-submenu').hide();
        }
    );

    //Acessibilidade
    // $('#font-plus-button').click(function() {
    // 	let tamanhoFonte = $('#content').css('font-size');
    // 	let tf = parseFloat(tamanhoFonte);
    // 	if (tf < 29) {
    // 		$('#content').css({ 'font-size': tf + 5 });
    // 	}
    // });
    // $('#font-less-button').click(function() {
    // 	let tamanhoFonte = $('#content').css('font-size');
    // 	let tf = parseFloat(tamanhoFonte);
    // 	if (tf > 14) {
    // 		$('#content').css({ 'font-size': tf - 5 });
    // 	}
    // });

    // $("#background-contrast-button").click(() => {
    //     if ($(document).find(".p5-bgcolor-gray").length) {
    //         $(".p5-accessibility-body").removeClass("p5-bgcolor-gray").addClass("p5-bgcolor-black");
    //         $(".p5-accessibility-content").removeClass("p5-bgcolor-white").addClass("p5-bgcolor-black");
    //     } else if ($(document).find(".p5-bgcolor-black").length) {
    //         $(".p5-accessibility-body").removeClass("p5-bgcolor-black").addClass("p5-bgcolor-gray");
    //         $(".p5-accessibility-content").removeClass("p5-bgcolor-black").addClass("p5-bgcolor-white");
    //     }
    // });

    // // Menu fixed scroll
    // var menuTop = $("#menu-desktop").offset().top;
    // var menuHeight = $("#menu-desktop").outerHeight();
    // $(window).scroll(function(){
    //     var scrollTop = $(window).scrollTop();
    //     if(scrollTop > (menuTop) )
    //     {
    //         $("#menu-desktop").addClass('navbar-fixed-top');
    //         $("body").css('margin-top', menuHeight);
    //         $("#footer-btn-back-top").show("slow");
    //     } else {
    //         $("#menu-desktop").removeClass(' navbar-fixed-top');
    //         $("body").css('margin-top', 0);
    //         $("#footer-btn-back-top").hide("slow");
    //     }
    // });

    $(document).off('click', '.menu-mobile');
    $(document).on('click', '.menu-mobile', function (e) {
        e.stopPropagation();
        $('.menu-mobile-container').addClass('open');
    });

    $(document).off('click', '.menu-mobile-container-click');
    $(document).on('click', '.menu-mobile-container-click', function (e) {
        e.stopPropagation();
        $('.menu-mobile-container').removeClass('open');
        (<any>$('.collapse')).collapse('hide');
    });

    $(document).on('click', function (e) {
        if ($(e.target).closest('.menu-mobile-container').length === 0) {
            $('.menu-mobile-container').removeClass('open');
            (<any>$('.collapse')).collapse('hide');
        }
    });

    /*Search*/
    $('#search-btn').click(function () {
        let search: any = $('#search').val();
        if (search.length > 2) {
            window.location.href = '/#/search/' + encodeURIComponent(search);
        }
    });

    $('#search').keyup(function (event: any) {
        if (event.keyCode == 13) {
            $('#search-btn').click();
        }
    });

    $('#search-btn-m').click(function () {
        let search: any = $('#search-m').val();
        if (search.length > 2) {
            window.location.href = '/#/search/' + encodeURIComponent(search);
        }
    });

    $('#search-m').keyup(function (event: any) {
        if (event.keyCode == 13) {
            $('#search-btn-m').click();
        }
    });

    $('#search-m').click(function (event: any) {
        event.stopPropagation();
    });

    // Back To TOP
    $(document).scroll(function () {
        var y = $(this).scrollTop();
        if (y > 400) {
            $('#footer-btn-back-top').fadeIn();
        } else {
            $('#footer-btn-back-top').fadeOut();
        }
    });

    $('#footer-btn-back-top').click(function () {
        $('body, html').animate({ scrollTop: 0 }, 900);
    });

    $('.error-popup').click(function () {
        $('.error-popup').hide();
    });

    // Functions 
    function setWithExpiry(key: any, value: any, ttl: any) {
        const now = new Date();
        const item = {
            value: value,
            expiry: now.getTime() + ttl
        };
        localStorage.setItem(key, JSON.stringify(item));
    }

    function getWithExpiry(key: any) {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    }

});
